/* eslint-disable no-undef */

import { getOrigin } from '../utils/browserutils'

export const isProduction = process.env.NODE_ENV === 'production'

export const isOnEnv = (env) => {
  const domain = getOrigin()

  return domain.split('.')[0].indexOf(env) !== -1
}

const GOOGLE_API_KEYS = {
  // LOCAL: 'AIzaSyCmy1QVbcx2v9wSFmQpQhxuGqRzA2lQ9u0',
  LOCAL: 'AIzaSyDc_ANtMhjO46hWUsP3XeKB_dkiOzCFdFo',
  // IT: 'AIzaSyAkWsArJMvfU6GVb7mTV7k0lKdOo4q5pNA',
  IT: 'AIzaSyC-5pc3nDQY1zYowaESiBZgfn8kD03o3Jk',
  PROD: 'AIzaSyCdflxJ2dhjjdytSPC7uWCyNC8-5chOI6U'
}

const formEndPointsByConvention = () => {
  const domain = getOrigin()

  if (isOnEnv('localhost') || isOnEnv('dev') || isOnEnv('diybillpaydev')) {
    return {
      apiGee: `${getOrigin()}`,
      content: 'it1-content.usbank.com/',
      transmit: `${domain}/Proxy/TS`,
      googleAPI: GOOGLE_API_KEYS.LOCAL,
      routingKey: 'it5',
      baseDigital: 'https://it2-content.usbank.com/en-us/mobileapp/hello/',
      baseDigitalSp: 'https://it2-content.usbank.com/es-us/mobileapp/hello/',
      baseAemUrl:
        'https://content.usbank.com/en-us/mobileapp/movemoney/billpay/products/',
      baseAemSpUrl:
        'https://content.usbank.com/es-us/mobileapp/movemoney/billpay/products/',
      externalPayments: 'externalpayments.model.json',
      digitalDisclaimer: 'digital-service-agreement.model.json'
    }
  }
  if (isOnEnv('it')) {
    return {
      apiGee: `${getOrigin()}`,
      content: 'it2-content.usbank.com/',
      transmit: `${domain}/Proxy/TS`,
      googleAPI: GOOGLE_API_KEYS.IT,
      baseDigital: 'https://it2-content.usbank.com/en-us/mobileapp/hello/',
      baseDigitalSp: 'https://it2-content.usbank.com/es-us/mobileapp/hello/',
      baseAemUrl:
        'https://content.usbank.com/en-us/mobileapp/movemoney/billpay/products/',
      baseAemSpUrl:
        'https://content.usbank.com/es-us/mobileapp/movemoney/billpay/products/',
      externalPayments: 'externalpayments.model.json',
      digitalDisclaimer: 'digital-service-agreement.model.json'
    }
  }

  if (isOnEnv('uat')) {
    return {
      apiGee: `${getOrigin()}`,
      // apiGee: 'https://uat1-onlinebanking.usbank.com/',
      content: 'uat1-content.usbank.com/',
      transmit: `${domain}/Proxy/TS`,
      googleAPI: GOOGLE_API_KEYS.IT,
      baseDigital: 'https://it2-content.usbank.com/en-us/mobileapp/hello/',
      baseDigitalSp: 'https://it2-content.usbank.com/es-us/mobileapp/hello/',
      baseAemUrl:
        'https://content.usbank.com/en-us/mobileapp/movemoney/billpay/products/',
      baseAemSpUrl:
        'https://content.usbank.com/es-us/mobileapp/movemoney/billpay/products/',
      externalPayments: 'externalpayments.model.json',
      digitalDisclaimer: 'digital-service-agreement.model.json'
    }
  }

  return {
    apiGee: `${getOrigin()}`,
    content: 'content.usbank.com/',
    transmit: `${domain}/Proxy/TS`,
    googleAPI: GOOGLE_API_KEYS.PROD,
    baseDigital: 'https://it2-content.usbank.com/en-us/mobileapp/hello/',
    baseDigitalSp: 'https://it2-content.usbank.com/es-us/mobileapp/hello/',
    baseAemUrl:
      'https://content.usbank.com/en-us/mobileapp/movemoney/billpay/products/',
    baseAemSpUrl:
      'https://content.usbank.com/es-us/mobileapp/movemoney/billpay/products/',
    externalPayments: 'externalpayments.model.json',
    digitalDisclaimer: 'digital-service-agreement.model.json'
  }
}

const endpoints =
  typeof window !== 'undefined' ? formEndPointsByConvention() : {}

const apiGeeDomain = `${endpoints.apiGee}/digital/api/`
const contentDomain = `https://${endpoints.content}`
const googleAPIkey = `${endpoints.googleAPI}`
const ROUTINGKEY = endpoints?.routingKey || ''
const BASE_PATH = isOnEnv('diybillpaydev')
  ? '/digital/moneymovement'
  : '/digital/moneymovement/payeemanagement-billpay'

// https://it-api.us.bank-dns.com/money-movement/graphql/v1',
const API_CONST = {
  graphql: {
    query: 'money-movement/graphql/v1',
    mutation: 'money-movement/graphql/v1'
  },
  rest: {
    query: 'money-movement/payee-mgmt/v1'
  }
}
const poaUrl = 'services/customer-management/servicing/v1'

export {
  API_CONST,
  endpoints,
  apiGeeDomain,
  contentDomain,
  googleAPIkey,
  BASE_PATH,
  ROUTINGKEY,
  poaUrl
}
